<div [@slideInOut]="active ? 'show' : 'hide'" class="legend-animate-container">
    <div [@.disabled]="disableAnimation()">
        <mat-accordion multi="false" >
            <!-- [togglePosition]="'before'" -->
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.RoadNetwork"|translate}}

                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg1_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.RoadNetwork"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.RailNetwork"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg2_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.RailNetwork"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.LandUse"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg3_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.LandUse"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Hydrography"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg4_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Hydrography"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Intersections"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg5_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Intersections"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Buildings"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg6_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Buildings"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.ConstructionsVariousObjects"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg7_10k_{{translateService.currentLang.slice(0, -1)}}.png"
                        alt='{{"legend.ConstructionsVariousObjects"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Relief"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg8_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Relief"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.WallsAndLimits"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg9_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.WallsAndLimits"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.ElectricNetwork"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg10_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.ElectricNetwork"|translate}}'>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{"legend.Pipelines"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/Img10k/leg11_10k_{{translateService.currentLang.slice(0, -1)}}.png" alt='{{"legend.Pipelines"|translate}}'>
                </div>
            </mat-expansion-panel>

        </mat-accordion>
    </div>
</div>